export default {};
throw new Error(`Could not resolve "three/src/math/MathUtils.js" imported by "@appletosolutions/reactbits". Is it installed?`)